import {
  Button,
  Col,
  DatePicker,
  InputNumber,
  Row,
  Form,
  Typography,
  Select,
  Spin,
  Divider,
  Input
} from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { getUnits } from '../../services/unitService';
import { debounce } from '../Common/Debounce';
import LoadJsonToForm from '../../components/LoadJsonToForm';
import moment from 'moment';

const { Text } = Typography;

const formatUnitOffersJson = (valuesJson) => {
  valuesJson.unitOffers.forEach((unitOffer) => {
    if (unitOffer.endDate)
      unitOffer.startDate = moment(unitOffer.startDate);
    if (unitOffer.endDate) unitOffer.endDate = moment(unitOffer.endDate);
  });
};

function UnitOffersForm({
  initialValues,
  setInitialValues,
  onSubmit,
  status,
  setStatus,
  type
}) {
  const [fetching, setFetching] = useState(false);
  const [form] = Form.useForm();

  const [fetchedUnits, setFetchedUnits] = useState([]);
  const dateFormat = 'Do MMMM YYYY h:mm:ssA Z';

  const fetchUnitsHandler = debounce((unitSearch) => {
    setFetching(true);
    getUnits(0, 0, {
      unitSearch
    })
      .then((response) => {
        const data = response.data.paginatedList.map((unit) => ({
          label: `${unit.code}: ${unit.description}`,
          value: unit.unitId
        }));
        setFetchedUnits(data);
        setFetching(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });
  }, 250);

  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={onSubmit}
      initialValues={initialValues}
      form={form}>
      <Form.Item label="Course Offer Id*" name="courseOfferId">
        <Text>{initialValues.courseOfferId}</Text>
      </Form.Item>

      <>
        <LoadJsonToForm
          form={form}
          setInitialValues={setInitialValues}
          formatJson={formatUnitOffersJson}
        />
        <Form.List
          name={['unitOffers']}
          rules={[{ required: true, message: 'Add Unit Offer' }]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <>
                  <div
                    style={{
                      display: 'flex',
                      marginBottom: '10px'
                    }}>
                    <section>
                      <Form.Item
                        label="Unit*"
                        name={[name, 'unitId']}
                        fieldKey={[fieldKey, 'unitId']}>
                        <Select
                          mode={''}
                          fieldKey={[fieldKey, 'unitId']}
                          label={`Unit ${name}`}
                          placeholder="Search units"
                          options={fetchedUnits}
                          notFoundContent={
                            fetching ? <Spin size="small" /> : null
                          }
                          filterOption={false}
                          showSearch={true}
                          onSearch={fetchUnitsHandler}
                          style={{ width: '150%' }}></Select>
                      </Form.Item>

                      <Form.Item
                        label={`Unit Offer ${name} start Date`}
                        name={[name, 'startDate']}
                        fieldKey={[fieldKey, 'startDate']}
                        rules={[
                          {
                            required: true,
                            message: 'Please input start date!'
                          }
                        ]}>
                        <DatePicker
                          showTime={true}
                          showNow={false}
                          format={dateFormat}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                      <Form.Item
                        label={`Unit Offer ${name} end Date`}
                        name={[name, 'endDate']}
                        rules={[
                          {
                            required: true,
                            message: 'Please input end date!'
                          }
                        ]}>
                        <DatePicker
                          showTime={true}
                          showNow={false}
                          format={dateFormat}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                      <Divider />
                    </section>
                  </div>
                </>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  style={{ width: '60%' }}
                  icon={<PlusOutlined />}>
                  Add Unit Offers
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </>
      {status.type === 'ERROR' ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      {status.type === 'SUCCESS' ? (
        <Text type="success">Sucessful!</Text>
      ) : null}
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            {'Add Unit Offer'}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default UnitOffersForm;
